<template>
  <div>
    <div align="left" class="mt-5"></div>
    <div class="text-left">
      <b-row>
        <b-col md="4" class="my-1">
          <h5 class="h5 mb-3 text-primary font-weight-bold">Click2Buy</h5>
          <!-- <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group> -->
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <!-- <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group> -->
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <div>
            <b-dropdown
              :disabled="selected.length === 0"
              :variant="selected.length === 0 ? 'primary' : 'warning'"
              id="dropdown-1"
              text="Action"
              class="m-md-2"
            >
              <b-dropdown-item
                :disabled="
                  dataShowing.sum_of_showing_data + selected.length >
                  dataShowing.maximum_number_of_showing_data
                "
                @click="submitStatus('show')"
                href="#"
                >Show</b-dropdown-item
              >
              <b-dropdown-item @click="submitStatus('hide')" href="#"
                >Hide</b-dropdown-item
              >
            </b-dropdown>
            <router-link
              :to="{
                name: 'formClick2buy',
                params: { id: '-', proses: 'create' },
              }"
            >
              <b-button variant="primary">
                <img src="@/assets/create-new.svg" alt class="mr-2" /> Tambah
                Baru
              </b-button>
            </router-link>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>
          We're sorry, we're not able to retrieve this information at the
          moment, please try back later
        </p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        show-empty
        ref="selectableTable"
        responsive
        :items="getInfo"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
        filter-debounce="500"
        empty-text="loading"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:head(selected)="data">
          <b-row>
            <b-col md="1">
              <b-form-checkbox
                v-model="allSelected"
                :indeterminate="indeterminate"
                aria-describedby="items"
                aria-controls="items"
                @change="toggleAll"
              ></b-form-checkbox>
            </b-col>
            <b-col md="2">Tanggal di Tambahkan</b-col>
            <b-col md="3">Merchant</b-col>
            <b-col md="3">Product</b-col>
            <b-col md="2">Status</b-col>
            <b-col md="1">Tindakan</b-col>
          </b-row>
        </template>
        <template v-slot:cell(selected)="{ item }">
          <draggable
            @change="send()"
            handle=".handle"
            v-model="itemsDataHighlight"
            v-bind="dragOptions"
            group="people"
            :move="onMove"
            @start="isDragging = true"
            @end="isDragging = false"
          >
            <transition-group type="transition" :name="'flip-list'">
              <div v-for="click in itemsDataHighlight" :key="click">
                <b-row class="py-3">
                  <b-col md="1">
                    <span aria-hidden="true">
                      <b-form-checkbox
                        :id="'checkbox-' + click.id"
                        :name="'checkbox-' + click.id"
                        class="checkBox"
                        :value="true"
                        :unchecked-value="false"
                        @change="changeSelected(click.id, $event)"
                      >
                      </b-form-checkbox>
                    </span>
                  </b-col>
                  <b-col md="2">{{ click.created_at }}</b-col>
                  <b-col md="3">{{ click.merchant_name }}</b-col>
                  <b-col md="3">{{ click.product_name }}</b-col>
                  <b-col md="2">
                    <b-form-checkbox
                      @change="changeStatus(click)"
                      v-model="click.is_showing"
                      name="check-button"
                      switch
                    >
                      <label
                        class="text-primary font-weight-bold"
                        v-if="click.is_showing"
                        >Tampil</label
                      >
                      <label
                        class="font-weight-bold"
                        style="color: #424143"
                        v-else
                        >Tersembunyi</label
                      >
                    </b-form-checkbox>
                  </b-col>
                  <b-col md="1">
                    <template>
                      <router-link
                        v-b-tooltip.hover
                        title="Edit"
                        :to="{
                          name: 'formClick2buy',
                          params: { id: click.id, proses: 'edit' },
                        }"
                        class="text-dark"
                      >
                        <img
                          class="mr-2"
                          style="width: 18px"
                          src="@/assets/ic-edit.svg"
                          alt
                        />
                      </router-link>
                      <b-link
                        v-b-tooltip.hover
                        title="Delete"
                        class="text-dark"
                        @click="del(click.id)"
                      >
                        <img
                          src="@/assets/rectangle.svg"
                          style="width: 18px"
                          class="mr-2"
                          alt
                        />
                      </b-link>
                      <b-link>
                        <i
                          class="fas fa-bars handle"
                          style="cursor: pointer; font-size: 12px"
                        ></i>
                      </b-link>
                    </template>
                  </b-col>
                </b-row>
              </div>
            </transition-group>
          </draggable>
          <div v-for="click2 in itemsData" :key="click2">
            <b-row class="py-3">
              <b-col md="1">
                <span aria-hidden="true">
                  <b-form-checkbox
                    :id="'checkbox-' + click2.id"
                    :name="'checkbox-' + click2.id"
                    class="checkBox"
                    :value="true"
                    :unchecked-value="false"
                    @change="changeSelected(click2.id, $event)"
                  >
                  </b-form-checkbox>
                </span>
              </b-col>
              <b-col md="2">{{ click2.created_at }}</b-col>
              <b-col md="3">{{ click2.merchant_name }}</b-col>
              <b-col md="3">{{ click2.product_name }}</b-col>
              <b-col md="2">
                <b-form-checkbox
                  @change="changeStatus(click2)"
                  v-model="click2.is_showing"
                  name="check-button"
                  switch
                >
                  <label
                    class="text-primary font-weight-bold"
                    v-if="click2.is_showing"
                    >Tampil</label
                  >
                  <label style="color: #c4c7ca" v-else>Tersembunyi</label>
                </b-form-checkbox>
              </b-col>
              <b-col md="1">
                <template>
                  <router-link
                    v-b-tooltip.hover
                    title="Edit"
                    :to="{
                      name: 'formClick2buy',
                      params: { id: click2.id, proses: 'edit' },
                    }"
                    class="text-dark"
                  >
                    <img
                      class="mr-2"
                      style="width: 18px"
                      src="@/assets/ic-edit.svg"
                      alt
                    />
                  </router-link>
                  <b-link
                    v-b-tooltip.hover
                    title="Delete"
                    class="text-dark"
                    @click="del(click2.id)"
                  >
                    <img
                      src="@/assets/rectangle.svg"
                      style="width: 18px"
                      class="mr-2"
                      alt
                    />
                  </b-link>
                </template>
              </b-col>
            </b-row>
          </div>
        </template>
      </b-table>

      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{ totalRows }}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  data() {
    return {
      mainProps: {
        blank: true,
        blankColor: "#777",
        width: 50,
        height: 50,
        class: "m1",
      },
      modalShow: false,
      loading: true,
      errored: false,
      selected_field_true: true,
      selected_field_false: false,
      itemsData: [],
      itemsDataHighlight: [],
      items: [],
      selectMode: "multi",
      selected: [],
      allSelected: false,
      indeterminate: false,
      fields: [
        {
          key: "selected",
          class: "",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      detail: [],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: "",
      customerShow: false,
      product_detail: false,
      counthighlight: null,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      editable: true,
      isDragging: false,
      delayedDragging: false,
      list_from: "",
      list_to: "",
      dataShowing: "",
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
  },
  beforeCreate() {
    this.$refs.selectableTable.refresh();
  },
  created() {},
  mounted() {
    this.getShowingData();
    this.totalRows = this.items.length;
  },
  methods: {
    getShowingData() {
      const formData = new FormData();
      formData.append("search_param", "");
      formData.append("limit", 50);
      formData.append("page", 1);
      this.$store
        .dispatch("CLick2BuyModule/infoShowing")
        .then((response) => {
          this.dataShowing = response.data.data;
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },
    changeStatus(data) {
      this.$swal({
        title: "Are you sure?",
        text: "Change status data!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, change it!",
      }).then((result) => {
        if (result.value) {
          const formData = new FormData();
          formData.append("click_to_buy_id", data.id);
          formData.append("status", data.is_showing ? "show" : "hide");
          this.$store
            .dispatch("CLick2BuyModule/ChangeStatus", formData)
            .then((response) => {
              this.getShowingData();
              this.$refs.selectableTable.refresh();
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.$refs.selectableTable.refresh();
        }
      });
    },
    changeSelected(data, event) {
      if (event) {
        this.selected.push(data);
      } else {
        const index = this.selected.indexOf(data);
        this.selected.splice(index, 1);
      }
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      this.$store
        .dispatch("CLick2BuyModule/getAllClick2BuyNew", ctx.filter)
        .then((response) => {
          // let arr = response.data.data.map(data => {
          //   let article = JSON.parse(data.results);
          //   return {
          //     content: article.content.id,
          //     title: article.title.id,
          //     category: article.category
          //   };
          // });
          // vm.items = arr;
          vm.totalRows = response.data.data.length;
          vm.itemsDataHighlight = response.data.data.filter(
            (click2buy) => click2buy.status == "show"
          );
          vm.itemsData = response.data.data.filter(
            (click2buy) => click2buy.status != "show"
          );
          callback([
            {
              selected: "cek",
            },
          ]);
          this.loading = false;
        })
        .catch((error) => {
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          // Returning an empty array, allows table to correctly handle
          // internal busy state in case of error
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      // this.totalRows = filteredItems.length;
      // this.currentPage = 1;
    },
    del(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("CLick2BuyModule/delClick2buy", id);
          this.$refs.selectableTable.refresh();
          this.$swal("Deleted!", "Your file has been deleted.", "success");
        }
      });
    },
    onRowSelected(items) {
      this.selected = items;
    },
    submitStatus(status) {
      this.$swal({
        title: "Are you sure?",
        text: `You will ${status} this On Click2Buy!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, change it!",
      }).then((result) => {
        if (result.value) {
          const formData = new FormData();
          $.each(this.selected, (key, value) => {
            formData.append("click_to_buy_id", value);
            formData.append("status", status);
          });
          this.loading = true;
          this.$store
            .dispatch("CLick2BuyModule/ChangeStatus", formData)
            .then((response) => {
              this.getShowingData();
              this.selected = [];
              this.loading = false;
              this.$refs.selectableTable.refresh();
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1000,
              });
              console.log(response);
            })
            .catch((error) => {
              this.selected = [];
              this.loading = false;
              this.serverError = error.response;
              console.log(error);
            });
        }
      });

      // console.log(list);
    },
    toggleAll(checked) {
      if (
        this.selected.length ===
        this.itemsData.length + this.itemsDataHighlight.length
      ) {
        this.selected = [];
        $(".checkBox .custom-control-input").prop("checked", false);
        $(".checkBox .custom-control-input").attr("checked", false);
        $(".checkBox .custom-control-input").val(false);
      } else if (this.selected.length >= 1) {
        this.selected = [];
        $(".checkBox .custom-control-input").prop("checked", false);
        $(".checkBox .custom-control-input").attr("checked", false);
        $(".checkBox .custom-control-input").val(false);
      } else {
        $(".checkBox .custom-control-input").prop("checked", checked);
        $(".checkBox .custom-control-input").attr("checked", checked);
        $(".checkBox .custom-control-input").val(checked);
        this.itemsDataHighlight.forEach((item) => {
          this.selected.push(item.id);
        });
        this.itemsData.forEach((item) => {
          this.selected.push(item.id);
        });
      }
    },
    send() {
      this.LoadingPopupProductLocation = true;
      const orderData = new FormData();
      orderData.append("click_to_buy_id_from", this.list_from);
      orderData.append("click_to_buy_id_to", this.list_to);
      console.log(orderData);
      this.$store
        .dispatch("CLick2BuyModule/ChangeOrder", orderData)
        .then((response) => {
          this.$refs.selectableTable.refresh();
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((error) => {
          this.$refs.selectableTable.refresh();
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          console.log(error);
        });
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      this.list_from = draggedElement.id;
      this.list_to = relatedElement.id;
      return true;
    },
  },
  watch: {
    selected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (
        newVal.length ===
        this.itemsData.length + this.itemsDataHighlight.length
      ) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
  },
};
</script>

<style scoped>
.pointer-off {
  pointer-events: none;
}
.title {
  width: 120px;
}
</style>
